import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Sparkles, Download, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = 'gorulen_guncelleme';

export const GuncellemeBanner = () => {
  const [guncelleme, setGuncelleme] = useState(null);

  useEffect(() => {
    axios.get(`${API}/app-dosyalari`)
      .then(({ data }) => {
        const g = data.find((d) => d.slot === 'guncelleme');
        if (g?.dosya_adi && localStorage.getItem(KEY) !== g.yuklenme_tarihi) setGuncelleme(g);
      })
      .catch(() => {});
  }, []);

  if (!guncelleme) return null;

  const kapat = () => {
    localStorage.setItem(KEY, guncelleme.yuklenme_tarihi);
    setGuncelleme(null);
  };

  return (
    <div className="bg-emerald-600 text-white" data-testid="guncelleme-banner">
      <div className="container mx-auto px-4 sm:px-6 py-2 flex items-center gap-3 flex-wrap text-sm">
        <Sparkles className="w-4 h-4 shrink-0" />
        <span className="font-semibold">Yeni güncelleme var!</span>
        <span className="text-emerald-100 truncate">
          {guncelleme.surum_notu ? `${guncelleme.surum_notu} • ` : ''}{guncelleme.dosya_adi} • {new Date(guncelleme.yuklenme_tarihi).toLocaleDateString('tr-TR')}
        </span>
        <Button asChild size="sm" variant="secondary" className="h-7 ml-auto bg-white text-emerald-700 hover:bg-emerald-50" data-testid="guncelleme-banner-indir">
          <a href={`${API}/app-dosyalari/guncelleme/indir`} download={guncelleme.dosya_adi} onClick={kapat}>
            <Download className="w-3.5 h-3.5 mr-1" /> İndir
          </a>
        </Button>
        <button onClick={kapat} className="p-1 rounded hover:bg-emerald-700" title="Kapat" data-testid="guncelleme-banner-kapat">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
